var _templateObject = _taggedTemplateLiteralLoose(['\n  position: relative;\n'], ['\n  position: relative;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  cursor: pointer;\n'], ['\n  color: ', ';\n  cursor: pointer;\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  z-index: 2;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-top: 15px;\n'], ['\n  position: absolute;\n  z-index: 2;\n  top: 100%;\n  left: 50%;\n  transform: translate(-50%, 0);\n  padding-top: 15px;\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  width: 200px;\n  background-color: white;\n  color: ', ';\n  padding: 16px 20px;\n  background-color: white;\n  border: 1px solid ', ';\n\n  &:after,\n  &:before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: " ";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: white;\n    border-width: 10px;\n    margin-left: -10px;\n  }\n\n  &:before {\n    border-color: rgba(151, 151, 151, 0);\n    border-bottom-color: ', ';\n    border-width: 11px;\n    margin-left: -11px;\n  }\n'], ['\n  position: relative;\n  width: 200px;\n  background-color: white;\n  color: ', ';\n  padding: 16px 20px;\n  background-color: white;\n  border: 1px solid ', ';\n\n  &:after,\n  &:before {\n    bottom: 100%;\n    left: 50%;\n    border: solid transparent;\n    content: " ";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n  }\n\n  &:after {\n    border-color: rgba(255, 255, 255, 0);\n    border-bottom-color: white;\n    border-width: 10px;\n    margin-left: -10px;\n  }\n\n  &:before {\n    border-color: rgba(151, 151, 151, 0);\n    border-bottom-color: ', ';\n    border-width: 11px;\n    margin-left: -11px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Theme from '../../Theme';

export var Wrapper = styled.span(_templateObject);

var Text = styled.span(_templateObject2, Theme.colors.lightBlue);

var TooltipContainer = styled.div(_templateObject3);

var TooltipContent = styled.div(_templateObject4, Theme.colors.primaryOpacity, Theme.colors.deepGrey, Theme.colors.deepGrey);

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      text = _ref.text;

  var _useState = useState(false),
      hovering = _useState[0],
      setHovering = _useState[1];

  return React.createElement(
    Wrapper,
    {
      onMouseEnter: function onMouseEnter() {
        return setHovering(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setHovering(false);
      }
    },
    React.createElement(
      Text,
      null,
      children
    ),
    hovering && text ? React.createElement(
      TooltipContainer,
      null,
      React.createElement(
        TooltipContent,
        null,
        text
      )
    ) : null
  );
};

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  text: PropTypes.string.isRequired
} : {};

export default Tooltip;